import { render, staticRenderFns } from "./wall.vue?vue&type=template&id=31b0551d&scoped=true&"
import script from "./wall.vue?vue&type=script&lang=js&"
export * from "./wall.vue?vue&type=script&lang=js&"
import style0 from "./wall.vue?vue&type=style&index=0&id=31b0551d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b0551d",
  null
  
)

export default component.exports